import { useMessagingDirectMessagesChatCreate } from "@sidegigllc/api/client";
import { useNavigate } from "@tanstack/react-router";
import { hireNotReadyReasonFrom } from "domains/hire/hireReadiness";
import { useActiveLocationId } from "services/locationOrgContext";

export const useMessagePro = () => {
  const navigate = useNavigate();
  const [activeLocationId] = useActiveLocationId();
  const startChat = useMessagingDirectMessagesChatCreate();

  /** `context: "hire"` makes the API hold the chat until the location is ready to hire; shift chat sends none. */
  const messagePro = async (proId: number, { context }: { context?: "hire" } = {}) => {
    if (!activeLocationId) return;
    const result = await startChat
      .mutateAsync({ data: { pro_id: proId, location_id: activeLocationId, context } })
      // A refused Hire chat is explained by the app's mutation error handler (see `reportHireNotReady`), not thrown.
      .catch((error: unknown) => {
        if (hireNotReadyReasonFrom(error)) return null;
        throw error;
      });
    if (!result) return;
    void navigate({
      to: "/locations/$locationId/inbox/chat/$channelUrl",
      params: { locationId: String(activeLocationId), channelUrl: result.channel_url },
    });
  };

  return { messagePro, isLoading: startChat.isPending };
};
